export enum ELocationSettingKey {
    BANK_SLIP_DAYS_SEND = 'bank_slip_days_send',
    BANK_SLIP_DISCOUNT = 'bank_slip_discount',
    BANK_SLIP_DISCOUNT_VALUE = 'bank_slip_discount_value',
    BANK_SLIP_DISCOUNT_DAYS = 'bank_slip_discount_days',
    BANK_SLIP_LATE_FEE = 'bank_slip_late_fee',
    BANK_SLIP_LATE_FEE_VALUE = 'bank_slip_late_fee_value',
    BANK_SLIP_MIN_LIMIT = 'bank_slip_min_limit',
    BANK_SLIP_INTEREST_RATE = 'bank_slip_interest_rate',
    BLOCK_CUSTOMER_DEBT_ENABLE = 'block_customer_debt_enable',
    BLOCK_CUSTOMER_DEBT_DAYS = 'block_customer_debt_days',
    BLOCK_ORDER_PENDING_RATING = 'block_order_pending_rating',
    BLOCK_ORDER_EXPIRED_PAYMENT = 'block_order_expired_payment',
    CHAT_ANONYMOUS = 'chat_anonymous',
    COMMISSION_CALCULATION_BASIS = 'commission_calculation_basis',
    CUSTOMER_ANOTHER_BILLING = 'customer_another_billing',
    CUSTOMER_STATEMENT_PAYMENT_INFO = 'customer_statement_payment_info',
    DAYS_CUSTOMER_HIGH_RISK = 'days_customer_high_risk',
    DAYS_CUSTOMER_LOW_RISK = 'days_customer_low_risk',
    DEFAULT_PAYMENT_METHOD = 'default_payment_method',
    DENTISTRY_DENTAL_NOTATION = 'dentistry_dental_notation',
    DUE_BALANCE_MAX_VALUE = 'due_balance_max_value',
    EMAIL_CUSTOMER_NFE = 'email_customer_nfe',
    EXPORT_BILLING_TYPE = 'export_billing_type',
    INSTALLMENT_ENABLE = 'installment_enable',
    INSTALLMENT_MIN_ENABLE = 'installment_min_enable',
    INSTALLMENT_MAX_VALUE = 'installment_max_value',
    INVENTORY_ORDER_APPROVAL_ENABLE = 'inventory_order_approval_enable',
    INVENTORY_SECTOR_ENABLE = 'inventory_sector_enable',
    INVOICE_CLOSED_CHANGE = 'invoice_closed_change',
    INVOICE_CLOSING_DAY = 'invoice_closing_day',
    INVOICE_DUE_DAYS = 'invoice_due_days',
    INVOICE_TYPE = 'invoice_type',
    MOBILE_PAYMENT = 'mobile_payment',
    ORDER_IDENTIFICATION_CODE = 'order_identification_code',
    ORDER_ITEM_BLOCK_REMAKE = 'order_item_block_remake',
    ORDER_DEFAULT_EXT_NOTE = 'order_default_ext_note',
    ORDER_DEFAULT_WATCHER = 'order_default_watcher',
    ORDER_DELAY_STATUS_TYPE = 'order_delay_status_type',
    ORDER_DELIVERY_DAYS = 'order_delivery_days',
    ORDER_DELIVERY_ROUTE_ENABLE = 'order_delivery_route_enable',
    ORDER_LABORATORY_DELIVERY_DAYS = 'order_laboratory_delivery_days',
    ORDER_MAX_PRODUCTION_HOUR = 'order_max_production_hour',
    ORDER_MEDIA_TYPE = 'order_media_type',
    ORDER_MIN_DELIVERY_DAYS = 'order_min_delivery_days',
    ORDER_MSG_MIN_DELIVERY_DAYS = 'order_msg_min_delivery_days',
    ORDER_NUMBERING = 'order_numbering',
    ORDER_PENDING_PRODUCTION_ENABLE = 'order_pending_production_enable',
    ORDER_PRINT_DENTISTRY = 'order_print_dentistry',
    ORDER_PRINT_DENTISTRY_INTERNAL_NOTE = 'order_print_dentistry_internal_note',
    ORDER_PRINT_LABORATORY_NAME = 'order_print_laboratory_name',
    ORDER_PRINT_MATERIAL = 'order_print_material',
    ORDER_PRINT_MATERIAL_NOTE = 'order_print_material_note',
    ORDER_PRINT_PROTOCOL_DENTISTRY_EXTERNAL_NOTE = 'order_print_protocol_dentistry_external_note',
    ORDER_PRINT_PROTOCOL_MATERIAL = 'order_print_protocol_material',
    ORDER_PRINT_PROTOCOL_MATERIAL_NOTE = 'order_print_protocol_material_note',
    ORDER_PRINT_NO_BALANCE = 'order_print_no_balance',
    ORDER_PRINT_ODONTOGRAM = 'order_print_odontogram',
    ORDER_PRINT_PRODUCTION = 'order_print_production',
    ORDER_PRINT_PRODUCTION_DATE = 'order_print_production_date',
    ORDER_PRODUCTION_VISIBLE = 'order_production_visible',
    ORDER_REMAKE_COMMISSION_ENABLE = 'order_remake_commission_enable',
    ORDER_REOPEN_DAYS = 'order_reopen_days',
    ORDER_TAX_VALUE = 'order_tax_value',
    ORDER_WITHOUT_DENTISTRY = 'order_without_dentistry',
    RECEIPT_DESCRIPTION = 'receipt_description',
    STATEMENT_DESCRIPTOR = 'statement_descriptor',
}

export enum ELocationSettingLabelType {
    PIMACO_28_51 = 1,
    BROTHER_62_30 = 2,
    ZEBRA_80_50 = 3,
    PIMACO_28_89 = 4,
    PIMACO_36_89 = 5,
    PIMACO_54_101 = 6,
    ZEBRA_50_30_X2 = 7,
    ZEBRA_50_30 = 8,
}

export enum ELocationSettingLabelIdentificationCode {
    QR_CODE = 1,
    BAR_CODE = 2,
}

export enum ELocationSettingLabelIdentificationType {
    ORDER = 1,
    ADDRESS = 2,
    ITEMS = 3,
}

export enum ELocationExportBillingType {
    STATEMENT = 'statement',
    INVOICE = 'invoice',
}
